import { StyledFlexConteiner } from "../../../../../Components/StyledComponents/Containers";

export const TreeNode: React.FC<{
  label: React.ReactNode;
  buttons: React.ReactNode;
}> = ({ label, buttons }) => {
  return (
    <StyledFlexConteiner $align_items="center" style={{ fontSize: "20px", height: "40px" }}>
      {label}
      <StyledFlexConteiner margin="0px 0px 0px 10px" $align_items="center">
        {buttons}
      </StyledFlexConteiner>
    </StyledFlexConteiner>
  );
};
